* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;

  gz-title[id='name'] {
    font-size: var(--body-size-small);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    text-transform: uppercase;
  }

  gz-text[id='date'] {
    font-size: var(--body-size-xsmall);
    flex: 0.6;
  }

  .description {
    font-size: var(--body-size);
    color: var(--main-titles-inputs-600);
    word-break: break-word;
  }

  gz-title[id='name'],
  gz-text[id='date'],
  .description {
    font-family: var(--font-family);
  }
}
